'use client';
import { NextPage } from 'next';
import React from 'react';
import Button from './Button';
import { OnboardingFormComponentProps } from '../utils/types';

const Optimize: NextPage<OnboardingFormComponentProps> = ({ currentStep, setCurrentStep, submitedForms, setSubmitedForms }) => {

    const handleButtonClick = () => {
        setSubmitedForms([...submitedForms, currentStep]);
        setCurrentStep(currentStep + 1);
    };

    return (
        <div className="flex flex-col gap-4 w-3/4">
            <h1 className="text-kartiv-gray-900 text-2xl font-semibold">Optimize your experience</h1>
            <p className="text-gray-600">
                Complete this quick quiz to improve your experience with Kartiv. By answering these straightforward questions, you'll enable us to provide you with better services in the near future.
            </p>
            <div className="pt-4">
                <Button label="Next" onClick={handleButtonClick} isArrow />
            </div>
        </div>
    );
};

export default Optimize;